import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import api, { handleApi } from "pages/api/api";
import { useAlert } from "pages/context/AlertContext";
import { useAuth } from "pages/context/AuthContext";
import PageHeader from "pages/components/PageHeader";
import ProjectTable from "pages/components/ProjectTable/ProjectTable";
import { createAutocompleteFilter } from "pages/utils/autocompleteFilter";
import DialogIncentivoResultados from "./components/DialogIncentivoResultados";
import DialogIncentivoResultadoDetalhe from "./components/DialogIncentivoResultadoDetalhe";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import Draggable from "react-draggable";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import {
  Accordion,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  AccordionDetails,
  AccordionSummary,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  IconButton,
  Paper,
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";

function PaperComponent(props) {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"], input, textarea, select, button'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function hojeISO() {
  return new Date().toISOString().slice(0, 10);
}

function toISODate(v) {
  if (!v) return "";
  return String(v).slice(0, 10);
}

function normalizarTexto(v) {
  return String(v || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();
}

function obterRegraSomaVendas(catalogos) {
  return (catalogos?.tiposDesafio || []).find((x) => {
    const txt = normalizarTexto(`${x.codigo || ""} ${x.nome || ""}`);
    return txt.includes("soma") && txt.includes("venda");
  });
}

function obterCondicaoQuantidade(catalogos) {
  return (catalogos?.tiposCondicao || []).find((x) => {
    const txt = normalizarTexto(`${x.codigo || ""} ${x.nome || ""}`);
    return txt.includes("qtd") || txt.includes("quantidade");
  });
}

function obterCondicaoClientes(catalogos) {
  return (catalogos?.tiposCondicao || []).find((x) => String(x.codigo || "") === "CLIENTES");
}

function obterOperadorMaiorIgual(catalogos) {
  return (catalogos?.tiposOperador || []).find((x) => String(x.codigo || "") === ">=");
}

export default function Incentivos() {
  const { showAlert } = useAlert();
  const { temPermissao, userData } = useAuth();

  const location = useLocation();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openAdd, setOpenAdd] = useState(false);
  const [novo, setNovo] = useState({
    nome: "",
    dataini: hojeISO(),
    datafim: hojeISO(),
    reffabricante: "",
    idfuncaoresponsavel: null,
    idfuncaoequipa: null,
    inativo: 0,
    beneficio_empresa: false,
    obs: "",
  });

  const [openEdit, setOpenEdit] = useState(false);
  const [sel, setSel] = useState(null);

  const [catalogos, setCatalogos] = useState(null);
  const [doc, setDoc] = useState({
    desafios: [],
    desafiosRegras: [],
    materiais: [],
    patamares: [],
    condicoes: [],
    clientesExcluidos: [],
  });
  const [expandedDesafio, setExpandedDesafio] = useState(null);
  const [expandedPatamar, setExpandedPatamar] = useState(null);

  const [historicoSubmarcas, setHistoricoSubmarcas] = useState({
    modo: "TODOS",
    datainicial: "",
    datafinal: "",
    submarcas: [],
  });

  const [submarcasHistoricoOptions, setSubmarcasHistoricoOptions] = useState([]);

  const [filtrosClientes, setFiltrosClientes] = useState({
    segmentopotencial: [],
    segmenton1: [],
    segmenton2: [],
    segmenton3: [],
    grupos_clientes: [],
    bloq_for: [],
    bloq_fat: [],
    bloq_ord: [],
  });

  const [openDesafio, setOpenDesafio] = useState(false);
  const [desafioEditId, setDesafioEditId] = useState(0);
  const [novoDesafio, setNovoDesafio] = useState({
    nome: "",
    ordem: 1,
    ambito_apuramento: "VENDEDOR",
    obs: "",
  });

  const [openMaterial, setOpenMaterial] = useState(false);
  const [materialTargetDesafio, setMaterialTargetDesafio] = useState(null);
  const [novoMaterial, setNovoMaterial] = useState({
    refmaterial: "",
    fator_equivalencia: "1",
    tipos: ["PRINCIPAL"],
  });

  const [materiaisOptions, setMateriaisOptions] = useState([]);
  const [materiaisSel, setMateriaisSel] = useState([]);
  const [materialPesquisa, setMaterialPesquisa] = useState("");

  const [openPatamar, setOpenPatamar] = useState(false);
  const [patamarEditId, setPatamarEditId] = useState(0);
  const [patamarTargetDesafio, setPatamarTargetDesafio] = useState(null);
  const [novoPatamar, setNovoPatamar] = useState({
    ordem: 1,
    descricao: "",
    idtipobeneficio: "",
    beneficio: "",
    beneficio_aplicacao: "FIXO",
    obs: "",
  });

  const [openCondicao, setOpenCondicao] = useState(false);
  const [condicaoEditId, setCondicaoEditId] = useState(0);
  const [condicaoTargetPatamar, setCondicaoTargetPatamar] = useState(null);
  const [condicaoTargetDesafio, setCondicaoTargetDesafio] = useState(null);
  const [novaCondicao, setNovaCondicao] = useState({
    ordem: 1,
    idtipocondicao: "",
    idtipooperador: "",
    valor: "",
    obs: "",
  });

  const [openResultados, setOpenResultados] = useState(false);
  const [resultados, setResultados] = useState([]);
  const [incentivoResultados, setIncentivoResultados] = useState(null);
  const [periodoResultados, setPeriodoResultados] = useState({
    datainicial: "",
    datafinal: "",
  });

  const [openResultadoDetalhe, setOpenResultadoDetalhe] = useState(false);
  const [resultadoDetalhe, setResultadoDetalhe] = useState([]);
  const [resultadoDetalheTitulo, setResultadoDetalheTitulo] = useState("");

  const carregar = async () => {
    setLoading(true);
    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivos", { incluirInativos: true })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setData(Array.isArray(payload) ? payload : []);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const id = Number(params.get("ccIncentivo") || 0);
    const datainicial = params.get("datainicial");
    const datafinal = params.get("datafinal");

    if (!id || !data.length) return;

    const incentivo = data.find((x) => Number(x.id) === id);

    if (!incentivo) return;

    carregarResultados(incentivo, {
      datainicial,
      datafinal,
    });
  }, [location.search, data]);

  const carregarCatalogos = async () => {
    const [payload, err] = await handleApi(api.post("Comercial/SelIncentivosCatalogos", {}));
    if (err) {
      showAlert(err, "error");
      return null;
    }
    setCatalogos(payload || {});
    return payload || {};
  };

  const carregarClientesExcluidos = async (idincentivo) => {
    if (!idincentivo) return [];

    const [payload, err] = await handleApi(
      api.post("Comercial/SelIncentivosClientesExcluidos", { idincentivo })
    );

    if (err) {
      showAlert(err, "error");
      return [];
    }

    return Array.isArray(payload) ? payload : [];
  };

  const filtrosClientesDefault = (cats) => ({
    segmentopotencial: (cats?.segmentoPotencial || [])
      .map((x) => String(x?.nome || "").trim())
      .filter(Boolean),

    segmenton1: (cats?.segmentoN1 || []).map((x) => String(x?.nome || "").trim()).filter(Boolean),

    segmenton2: (cats?.segmentoN2 || []).map((x) => String(x?.nome || "").trim()).filter(Boolean),

    segmenton3: (cats?.segmentoN3 || []).map((x) => String(x?.nome || "").trim()).filter(Boolean),

    grupos_clientes: (cats?.gruposClientes || [])
      .map((x) => String(x?.ref || "").trim())
      .filter((ref) => ref && !["Z010", "Z011", "Z012"].includes(ref)),

    bloq_for: (cats?.bloqueiosFornecimento || [])
      .map((x) => String(x?.ref || "").trim())
      .filter(Boolean),

    bloq_fat: (cats?.bloqueiosFaturacao || [])
      .map((x) => String(x?.ref || "").trim())
      .filter(Boolean),

    bloq_ord: (cats?.bloqueiosOrdem || []).map((x) => String(x?.ref || "").trim()).filter(Boolean),
  });

  const abrirEdicao = async (r) => {
    setLoading(true);
    try {
      const cats = catalogos || (await carregarCatalogos()) || {};

      const [payload, err] = await handleApi(api.post("Comercial/ObterIncentivo", { id: r.id }));
      if (err) {
        showAlert(err, "error");
        return;
      }

      const incentivo = payload?.incentivo || r;

      setSel({
        ...incentivo,
        dataini: toISODate(incentivo.dataini),
        datafim: toISODate(incentivo.datafim),
        reffabricante: incentivo.reffabricante || "",
        idfuncaoresponsavel: incentivo.idfuncaoresponsavel || null,
        idfuncaoequipa: incentivo.idfuncaoequipa || null,
        beneficio_empresa: Boolean(incentivo.beneficio_empresa),
        obs: incentivo.obs || "",
      });

      setHistoricoSubmarcas({
        modo: incentivo.clientes_historico_modo || "TODOS",
        datainicial: toISODate(incentivo.clientes_historico_dataini),
        datafinal: toISODate(incentivo.clientes_historico_datafim),
        submarcas: Array.isArray(payload?.clientesHistoricoSubmarcas)
          ? payload.clientesHistoricoSubmarcas
          : [],
      });

      setSubmarcasHistoricoOptions([]);

      const defaultsFiltros = filtrosClientesDefault(cats);
      const gravados = payload?.filtrosClientes || {};

      const filtrosJaConfigurados = Number(incentivo?.filtros_clientes_configurados || 0) === 1;

      const usarGravadosOuDefault = (gravadosLista, defaultLista) =>
        filtrosJaConfigurados
          ? (Array.isArray(gravadosLista) ? gravadosLista : [])
              .map((x) => String(x || "").trim())
              .filter(Boolean)
          : defaultLista;

      setFiltrosClientes({
        segmentopotencial: usarGravadosOuDefault(
          gravados.segmentopotencial,
          defaultsFiltros.segmentopotencial
        ),
        segmenton1: usarGravadosOuDefault(gravados.segmenton1, defaultsFiltros.segmenton1),
        segmenton2: usarGravadosOuDefault(gravados.segmenton2, defaultsFiltros.segmenton2),
        segmenton3: usarGravadosOuDefault(gravados.segmenton3, defaultsFiltros.segmenton3),
        grupos_clientes: usarGravadosOuDefault(
          gravados.grupos_clientes,
          defaultsFiltros.grupos_clientes
        ),
        bloq_for: usarGravadosOuDefault(gravados.bloq_for, defaultsFiltros.bloq_for),
        bloq_fat: usarGravadosOuDefault(gravados.bloq_fat, defaultsFiltros.bloq_fat),
        bloq_ord: usarGravadosOuDefault(gravados.bloq_ord, defaultsFiltros.bloq_ord),
      });

      const clientesExcluidos = await carregarClientesExcluidos(r.id);

      setDoc({
        desafios: Array.isArray(payload?.desafios) ? payload.desafios : [],
        desafiosRegras: Array.isArray(payload?.desafiosRegras) ? payload.desafiosRegras : [],
        materiais: Array.isArray(payload?.materiais) ? payload.materiais : [],
        patamares: Array.isArray(payload?.patamares) ? payload.patamares : [],
        condicoes: Array.isArray(payload?.condicoes) ? payload.condicoes : [],
        clientesExcluidos,
      });

      setExpandedDesafio(null);
      setExpandedPatamar(null);
      setOpenEdit(true);
    } finally {
      setLoading(false);
    }
  };

  const inserir = async () => {
    if (!novo.nome?.trim()) return showAlert("Indica o nome do incentivo.", "warning");
    if (!novo.dataini || !novo.datafim) return showAlert("Indica o período.", "warning");

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/InsIncentivo", {
          nome: novo.nome.trim().toUpperCase(),
          dataini: novo.dataini,
          datafim: novo.datafim,
          reffabricante: novo.reffabricante?.trim() || null,
          idfuncaoresponsavel: novo.idfuncaoresponsavel || null,
          idfuncaoequipa: novo.idfuncaoequipa || null,
          inativo: novo.inativo,
          beneficio_empresa: novo.beneficio_empresa ? 1 : 0,
          obs: novo.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Incentivo criado.", meta?.severity || "success");
      setOpenAdd(false);
      setNovo({
        nome: "",
        dataini: hojeISO(),
        datafim: hojeISO(),
        reffabricante: "",
        idfuncaoresponsavel: null,
        idfuncaoequipa: null,
        inativo: 0,
        beneficio_empresa: false,
        obs: "",
      });
      await carregar();
    } finally {
      setLoading(false);
    }
  };

  const gravarEdicao = async () => {
    if (!sel?.nome?.trim()) return showAlert("Indica o nome do incentivo.", "warning");
    if (!sel.dataini || !sel.datafim) return showAlert("Indica o período.", "warning");

    if (historicoSubmarcas.modo === "SEM_COMPRAS_SUBMARCAS") {
      if (!historicoSubmarcas.datainicial || !historicoSubmarcas.datafinal) {
        return showAlert("Indica o período histórico dos clientes.", "warning");
      }

      if (historicoSubmarcas.datainicial > historicoSubmarcas.datafinal) {
        return showAlert(
          "A data inicial do histórico não pode ser superior à data final.",
          "warning"
        );
      }

      if (
        !Array.isArray(historicoSubmarcas.submarcas) ||
        historicoSubmarcas.submarcas.length === 0
      ) {
        return showAlert(
          "Seleciona pelo menos uma submarca para o histórico de clientes.",
          "warning"
        );
      }
    }

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivo", {
          id: sel.id,
          nome: sel.nome.trim().toUpperCase(),
          dataini: sel.dataini,
          datafim: sel.datafim,
          reffabricante: sel.reffabricante?.trim() || null,
          idfuncaoresponsavel: sel.idfuncaoresponsavel || null,
          idfuncaoequipa: sel.idfuncaoequipa || null,
          inativo: sel.inativo,
          beneficio_empresa: sel.beneficio_empresa ? 1 : 0,

          clientes_historico_modo: historicoSubmarcas.modo,
          clientes_historico_dataini:
            historicoSubmarcas.modo === "SEM_COMPRAS_SUBMARCAS"
              ? historicoSubmarcas.datainicial
              : null,
          clientes_historico_datafim:
            historicoSubmarcas.modo === "SEM_COMPRAS_SUBMARCAS"
              ? historicoSubmarcas.datafinal
              : null,

          obs: sel.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      const refsSubmarcas =
        historicoSubmarcas.modo === "SEM_COMPRAS_SUBMARCAS"
          ? (historicoSubmarcas.submarcas || [])
              .map((x) => String(x?.ref || "").trim())
              .filter(Boolean)
          : [];

      const [_payloadSubmarcas, errSubmarcas] = await handleApi(
        api.post("Comercial/UpdIncentivoHistoricoSubmarcas", {
          idincentivo: sel.id,
          refssubmarcas: refsSubmarcas,
        })
      );

      if (errSubmarcas) {
        showAlert(errSubmarcas, "error");
        return;
      }

      const [_payloadFiltros, errFiltros] = await handleApi(
        api.post("Comercial/UpdIncentivoFiltrosClientes", {
          idincentivo: sel.id,

          segmentopotencial: filtrosClientes.segmentopotencial || [],
          segmenton1: filtrosClientes.segmenton1 || [],
          segmenton2: filtrosClientes.segmenton2 || [],
          segmenton3: filtrosClientes.segmenton3 || [],

          grupos_clientes: filtrosClientes.grupos_clientes || [],

          bloq_for: filtrosClientes.bloq_for || [],
          bloq_fat: filtrosClientes.bloq_fat || [],
          bloq_ord: filtrosClientes.bloq_ord || [],
        })
      );

      if (errFiltros) {
        showAlert(errFiltros, "error");
        return;
      }

      showAlert(meta?.message || "Incentivo atualizado.", meta?.severity || "success");
      setOpenEdit(false);

      await carregar();
    } finally {
      setLoading(false);
    }
  };

  const criarGrupoRapido = async () => {
    if (!sel?.id) return;

    const ordem = (doc.desafios || []).length + 1;
    const nome = `GRUPO ${ordem}`;
    const cats = catalogos || (await carregarCatalogos()) || {};

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post("Comercial/InsIncentivoDesafio", {
          idincentivo: sel.id,
          nome,
          ordem,
          ambito_apuramento: "VENDEDOR",
          obs: null,
        })
      );

      if (err) return showAlert(err, "error");

      const iddesafio = payload?.id || null;
      const regraSoma = obterRegraSomaVendas(cats);

      if (iddesafio && regraSoma?.id) {
        const [_rPayload, rErr] = await handleApi(
          api.post("Comercial/UpdIncentivoDesafioRegras", {
            iddesafio,
            idsregras: [Number(regraSoma.id)],
          })
        );

        if (rErr) return showAlert(rErr, "error");
      }

      showAlert(meta?.message || "Grupo criado.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarDesafio = async () => {
    if (!sel?.id) return;
    if (!novoDesafio.nome?.trim()) return showAlert("Indica o nome do desafio.", "warning");

    const isEdit = Number(desafioEditId || 0) > 0;

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoDesafio" : "Comercial/InsIncentivoDesafio", {
          id: desafioEditId,
          idincentivo: sel.id,
          nome: novoDesafio.nome.trim().toUpperCase(),
          ordem: Number(novoDesafio.ordem || 1),
          ambito_apuramento: novoDesafio.ambito_apuramento || "VENDEDOR",
          obs: novoDesafio.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Desafio gravado.", meta?.severity || "success");

      setOpenDesafio(false);
      setDesafioEditId(0);
      setNovoDesafio({
        nome: "",
        ordem: 1,
        ambito_apuramento: "VENDEDOR",
        obs: "",
      });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(isEdit ? desafioEditId : payload?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const removerDesafio = async (d) => {
    if (!d?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoDesafio", { id: d.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Desafio eliminado.", meta?.severity || "success");
      await abrirEdicao({ id: sel.id });
    } finally {
      setLoading(false);
    }
  };

  const toggleRegraDesafio = async (desafio, idtipodesafio, checked) => {
    if (!sel?.id || !desafio?.id) return;

    const atuais = (doc.desafiosRegras || [])
      .filter((r) => Number(r.iddesafio) === Number(desafio.id))
      .map((r) => Number(r.idtipodesafio));

    const idsregras = checked
      ? Array.from(new Set([...atuais, Number(idtipodesafio)]))
      : atuais.filter((id) => Number(id) !== Number(idtipodesafio));

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivoDesafioRegras", {
          iddesafio: desafio.id,
          idsregras,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Regras atualizadas.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(desafio.id);
    } finally {
      setLoading(false);
    }
  };

  const pesquisarSubmarcasHistorico = async (term) => {
    const texto = String(term || "").trim();

    if (!sel?.reffabricante) {
      setSubmarcasHistoricoOptions([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Comercial/SelIncentivosHistoricoSubmarcasCombo", {
        term: texto,
        reffabricante: sel.reffabricante,
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    setSubmarcasHistoricoOptions(Array.isArray(payload) ? payload : []);
  };

  const pesquisarMateriais = async (term) => {
    const texto = String(term || "").trim();

    if (texto.length < 2) {
      setMateriaisOptions([]);
      return;
    }

    const [payload, err] = await handleApi(
      api.post("Comercial/SelIncentivosMateriaisCombo", {
        term: texto,
        reffabricante: sel?.reffabricante || "",
      })
    );

    if (err) {
      showAlert(err, "error");
      return;
    }

    const tiposSelecionados =
      Array.isArray(novoMaterial.tipos) && novoMaterial.tipos.length > 0
        ? novoMaterial.tipos
        : ["PRINCIPAL"];

    setMateriaisOptions(
      (Array.isArray(payload) ? payload : []).filter((m) => {
        const ref = String(m.ref || "");

        const tiposJaAssociados = new Set(
          (doc.materiais || [])
            .filter(
              (x) =>
                Number(x.iddesafio) === Number(materialTargetDesafio?.id) &&
                String(x.refmaterial || "") === ref
            )
            .map((x) => String(x.tipo || "PRINCIPAL"))
        );

        return tiposSelecionados.some((tipo) => !tiposJaAssociados.has(tipo));
      })
    );
  };

  const adicionarMaterial = async () => {
    if (!sel?.id) return;
    if (!materialTargetDesafio?.id) return;

    if (!Array.isArray(novoMaterial.tipos) || novoMaterial.tipos.length === 0)
      return showAlert("Seleciona Principal, Bónus ou ambos.", "warning");

    setLoading(true);
    try {
      const tiposSelecionados =
        Array.isArray(novoMaterial.tipos) && novoMaterial.tipos.length > 0
          ? novoMaterial.tipos
          : ["PRINCIPAL"];

      let associacoesCriadas = 0;

      for (const material of materiaisSel) {
        const refmaterial = String(material.ref || "").trim();

        const tiposJaAssociados = new Set(
          (doc.materiais || [])
            .filter(
              (x) =>
                Number(x.iddesafio) === Number(materialTargetDesafio.id) &&
                String(x.refmaterial || "") === refmaterial
            )
            .map((x) => String(x.tipo || "PRINCIPAL"))
        );

        const tiposEmFalta = tiposSelecionados.filter((tipo) => !tiposJaAssociados.has(tipo));

        for (const tipo of tiposEmFalta) {
          const [payload, err] = await handleApi(
            api.post("Comercial/InsIncentivoDesafioMaterial", {
              iddesafio: materialTargetDesafio.id,
              refmaterial,
              fator_equivalencia: Number(
                String(novoMaterial.fator_equivalencia || "1").replace(",", ".")
              ),
              tipo,
            })
          );

          if (err) return showAlert(err, "error");

          associacoesCriadas += 1;
        }
      }

      showAlert(
        `${materiaisSel.length} material${materiaisSel.length === 1 ? "" : "ais"} processado${
          materiaisSel.length === 1 ? "" : "s"
        } · ${associacoesCriadas} associação${associacoesCriadas === 1 ? "" : "ões"} criada${
          associacoesCriadas === 1 ? "" : "s"
        }.`,
        "success"
      );

      setOpenMaterial(false);
      setNovoMaterial({
        refmaterial: "",
        fator_equivalencia: "1",
        tipos: ["PRINCIPAL"],
      });
      setMateriaisSel([]);
      setMateriaisOptions([]);
      setMaterialPesquisa("");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(materialTargetDesafio.id);
    } finally {
      setLoading(false);
    }
  };

  const removerMaterial = async (m, iddesafio) => {
    if (!m?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoDesafioMaterial", { id: m.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Material removido.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const removerMaterialCompleto = async (m, iddesafio) => {
    const associacoes = Array.isArray(m?.associacoes) ? m.associacoes : [m];

    if (associacoes.length === 0) return;

    setLoading(true);

    try {
      for (const associacao of associacoes) {
        if (!associacao?.id) continue;

        const [_payload, err] = await handleApi(
          api.post("Comercial/DelIncentivoDesafioMaterial", {
            id: associacao.id,
          })
        );

        if (err) return showAlert(err, "error");
      }

      showAlert("Material removido.", "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarPatamar = async () => {
    if (!sel?.id) return;
    if (!patamarTargetDesafio?.id) return;
    if (!novoPatamar.idtipobeneficio) return showAlert("Indica o tipo de benefício.", "warning");

    const isEdit = Number(patamarEditId || 0) > 0;

    setLoading(true);
    try {
      const [payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoPatamar" : "Comercial/InsIncentivoPatamar", {
          id: patamarEditId,
          iddesafio: patamarTargetDesafio.id,
          ordem: Number(novoPatamar.ordem || 1),
          descricao: novoPatamar.descricao?.trim() || null,
          idtipobeneficio: Number(novoPatamar.idtipobeneficio),
          beneficio: novoPatamar.beneficio?.trim() || null,
          beneficio_aplicacao: novoPatamar.beneficio_aplicacao || "FIXO",
          obs: novoPatamar.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      if (!isEdit && payload?.id) {
        const cats = catalogos || (await carregarCatalogos()) || {};

        const regraClientesQtdMinima = (cats?.tiposDesafio || []).find(
          (x) => String(x.codigo || "") === "CLIENTES_QTD_MINIMA"
        );

        const usaClientesQtdMinima =
          Boolean(regraClientesQtdMinima?.id) &&
          (doc.desafiosRegras || []).some(
            (r) =>
              Number(r.iddesafio) === Number(patamarTargetDesafio.id) &&
              Number(r.idtipodesafio) === Number(regraClientesQtdMinima.id)
          );

        const tipoCondicao = usaClientesQtdMinima
          ? obterCondicaoClientes(cats)
          : obterCondicaoQuantidade(cats);

        const operadorMaiorIgual = obterOperadorMaiorIgual(cats);

        if (tipoCondicao?.id && operadorMaiorIgual?.id) {
          const [_cPayload, cErr] = await handleApi(
            api.post("Comercial/InsIncentivoCondicao", {
              idpatamar: payload.id,
              idtipocondicao: Number(tipoCondicao.id),
              idtipooperador: Number(operadorMaiorIgual.id),
              valor: usaClientesQtdMinima ? 10 : 1,
              ordem: 1,
              obs: null,
            })
          );

          if (cErr) return showAlert(cErr, "error");
        }
      }

      showAlert(meta?.message || "Patamar gravado.", meta?.severity || "success");

      setOpenPatamar(false);
      setPatamarEditId(0);
      setNovoPatamar({
        ordem: 1,
        descricao: "",
        idtipobeneficio: "",
        beneficio: "",
        beneficio_aplicacao: "FIXO",
        obs: "",
      });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(patamarTargetDesafio.id);
      setExpandedPatamar(isEdit ? patamarEditId : payload?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const removerPatamar = async (p, iddesafio) => {
    if (!p?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoPatamar", { id: p.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Patamar eliminado.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(iddesafio);
    } finally {
      setLoading(false);
    }
  };

  const gravarCondicao = async () => {
    if (!sel?.id) return;
    if (!condicaoTargetPatamar?.id) return;
    if (!novaCondicao.idtipocondicao) return showAlert("Indica o tipo de condição.", "warning");
    if (!novaCondicao.idtipooperador) return showAlert("Indica o operador.", "warning");
    if (String(novaCondicao.valor || "").trim() === "")
      return showAlert("Indica o valor.", "warning");

    const isEdit = Number(condicaoEditId || 0) > 0;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post(isEdit ? "Comercial/UpdIncentivoCondicao" : "Comercial/InsIncentivoCondicao", {
          id: condicaoEditId,
          idpatamar: condicaoTargetPatamar.id,
          idtipocondicao: Number(novaCondicao.idtipocondicao),
          idtipooperador: Number(novaCondicao.idtipooperador),
          valor: Number(String(novaCondicao.valor).replace(",", ".")),
          ordem: Number(novaCondicao.ordem || 1),
          obs: novaCondicao.obs?.trim() || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Condição gravada.", meta?.severity || "success");

      setOpenCondicao(false);
      setCondicaoEditId(0);
      setNovaCondicao({
        ordem: 1,
        idtipocondicao: "",
        idtipooperador: "",
        valor: "",
        obs: "",
      });

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(condicaoTargetDesafio?.id || null);
      setExpandedPatamar(condicaoTargetPatamar.id);
    } finally {
      setLoading(false);
    }
  };

  const removerCondicao = async (c, p, d) => {
    if (!c?.id) return;

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/DelIncentivoCondicao", { id: c.id })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Condição eliminada.", meta?.severity || "success");

      await abrirEdicao({ id: sel.id });
      setExpandedDesafio(d?.id || null);
      setExpandedPatamar(p?.id || null);
    } finally {
      setLoading(false);
    }
  };

  const carregarResultados = async (incentivo, periodo = null) => {
    const idincentivo = Number(incentivo?.id || 0);

    if (idincentivo <= 0) {
      showAlert("Incentivo inválido.", "warning");
      return;
    }

    const periodoEfetivo = periodo || {
      datainicial: toISODate(incentivo.dataini),
      datafinal: toISODate(incentivo.datafim),
    };

    if (!periodoEfetivo.datainicial || !periodoEfetivo.datafinal) {
      showAlert("Indica a data inicial e a data final.", "warning");
      return;
    }

    if (periodoEfetivo.datainicial > periodoEfetivo.datafinal) {
      showAlert("A data inicial não pode ser superior à data final.", "warning");
      return;
    }

    setLoading(true);

    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivosResultadosVendedores", {
          idincentivo,
          datainicial: periodoEfetivo.datainicial,
          datafinal: periodoEfetivo.datafinal,
          idutilizador: userData?.id || 0,
          funcoes: userData?.funcoes || [],
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setIncentivoResultados(incentivo);
      setPeriodoResultados(periodoEfetivo);
      setResultados(Array.isArray(payload) ? payload : []);
      setOpenResultados(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const idincentivo = Number(params.get("ccIncentivo") || 0);
    const datainicial = params.get("datainicial") || "";
    const datafinal = params.get("datafinal") || "";

    if (!idincentivo || !Array.isArray(data) || data.length === 0) {
      return;
    }

    const incentivo = data.find((linha) => Number(linha?.id || 0) === idincentivo);

    if (!incentivo) {
      showAlert("Incentivo não encontrado.", "warning");

      window.history.replaceState({}, document.title, window.location.pathname);

      return;
    }

    window.history.replaceState({}, document.title, window.location.pathname);

    carregarResultados(incentivo, {
      datainicial,
      datafinal,
    });

    // A lista é carregada depois da entrada na página.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const abrirResultadoDetalhe = async (r) => {
    setLoading(true);
    try {
      const [payload, err] = await handleApi(
        api.post("Comercial/SelIncentivosResultadoDetalhe", {
          idincentivo: r.idincentivo,
          iddesafio: r.iddesafio,
          idpatamar: r.idpatamar,
          refvendedor: r.refvendedor,
          datainicial: periodoResultados.datainicial || null,
          datafinal: periodoResultados.datafinal || null,
        })
      );

      if (err) {
        showAlert(err, "error");
        return;
      }

      setResultadoDetalhe(Array.isArray(payload) ? payload : []);

      setResultadoDetalheTitulo(`${r.vendedor} · ${r.grupo} · ${r.patamar}`);

      setOpenResultadoDetalhe(true);
    } finally {
      setLoading(false);
    }
  };

  const rowActions = useMemo(
    () => [
      {
        id: "editar",
        icon: <EditIcon fontSize="small" />,
        tooltip: "Editar",
        color: "primary",
        visible: () => temPermissao("Menu Comercial", "u"),
        onClick: abrirEdicao,
      },
      {
        id: "resultados",
        icon: <EmojiEventsIcon fontSize="small" />,
        tooltip: "Resultados",
        color: "info",
        visible: () => temPermissao("Menu Comercial", "r"),
        onClick: (r) => carregarResultados(r),
      },
    ],
    [temPermissao]
  );

  const columns = useMemo(
    () => [
      { Header: "Nome", accessor: "nome", width: 260 },
      { Header: "Fabricantes", accessor: "fabricante", width: 220 },
      { Header: "Materiais", accessor: "materiais_resumo", width: 360 },
      {
        Header: "Data inicial",
        accessor: "dataini",
        width: 120,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Data final",
        accessor: "datafim",
        width: 120,
        Cell: ({ value }) => toISODate(value),
      },
      {
        Header: "Observações",
        accessor: "obs",
        width: 260,
      },
      {
        Header: "Ativo",
        accessor: "inativo",
        width: 100,
        filterType: "simNaoInverso",
        Cell: ({ value }) => (Number(value || 0) === 1 ? "Não" : "Sim"),
      },
    ],
    []
  );

  const toggleFiltroCliente = (campo, valor, checked) => {
    setFiltrosClientes((prev) => {
      const atuais = Array.isArray(prev?.[campo]) ? prev[campo] : [];

      return {
        ...prev,
        [campo]: checked
          ? Array.from(new Set([...atuais, valor]))
          : atuais.filter((x) => String(x) !== String(valor)),
      };
    });
  };

  const selecionarTodosFiltroCliente = (campo, valores) => {
    setFiltrosClientes((prev) => ({
      ...prev,
      [campo]: Array.from(
        new Set((valores || []).map((x) => String(x || "").trim()).filter(Boolean))
      ),
    }));
  };

  const limparFiltroCliente = (campo) => {
    setFiltrosClientes((prev) => ({
      ...prev,
      [campo]: [],
    }));
  };

  const atualizarClientesIncluidos = async (refcliente, incluir) => {
    if (!sel?.id) return;

    const atuais = (doc.clientesExcluidos || [])
      .filter((x) => Number(x.incluido || 0) === 1)
      .map((x) => String(x.refcliente || ""));

    const novos = incluir
      ? Array.from(new Set([...atuais, String(refcliente)]))
      : atuais.filter((x) => x !== String(refcliente));

    setLoading(true);
    try {
      const [_payload, err, meta] = await handleApi(
        api.post("Comercial/UpdIncentivosClientesIncluidosLote", {
          idincentivo: sel.id,
          refsclientes: novos,
          atualizado_por: userData?.id || null,
        })
      );

      if (err) return showAlert(err, "error");

      showAlert(meta?.message || "Clientes incluídos atualizados.", meta?.severity || "success");

      const clientesExcluidos = await carregarClientesExcluidos(sel.id);
      setDoc((p) => ({ ...p, clientesExcluidos }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageHeader />

      <MDBox pt={1}>
        <ProjectTable
          tableKey="incentivos"
          version="v1"
          columns={columns}
          data={data}
          loading={loading}
          rowActions={rowActions}
          toolbarActions={[
            {
              id: "novo-incentivo",
              label: "Novo Incentivo",
              color: "success",
              disabled: !temPermissao("Menu Comercial", "w"),
              onClick: async () => {
                if (!catalogos) await carregarCatalogos();
                setOpenAdd(true);
              },
            },
          ]}
          minWidth={980}
          maxHeight="68vh"
          emptyMessage="Sem incentivos para apresentar."
          actionsPosition="left"
        />
      </MDBox>

      <Dialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Novo Incentivo
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={novo.nome}
                onChange={(e) => setNovo((p) => ({ ...p, nome: e.target.value.toUpperCase() }))}
                fullWidth
              />
            </MDBox>

            <TextField
              label="Data inicial"
              type="date"
              value={novo.dataini}
              onChange={(e) => setNovo((p) => ({ ...p, dataini: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <TextField
              label="Data final"
              type="date"
              value={novo.datafim}
              onChange={(e) => setNovo((p) => ({ ...p, datafim: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <Autocomplete
              options={catalogos?.fabricantes || []}
              filterOptions={createAutocompleteFilter((o) => `${o?.ref || ""} ${o?.nome || ""}`)}
              value={
                (catalogos?.fabricantes || []).find(
                  (x) => String(x.ref || "") === String(novo.reffabricante || "")
                ) || null
              }
              onChange={(_, v) =>
                setNovo((p) => ({
                  ...p,
                  reffabricante: v?.ref || "",
                }))
              }
              getOptionLabel={(o) => (o?.nome ? `${o.nome} (${o.ref})` : o?.ref || "")}
              isOptionEqualToValue={(opt, val) => String(opt?.ref || "") === String(val?.ref || "")}
              renderInput={(params) => <TextField {...params} label="Fabricante" fullWidth />}
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              filterOptions={createAutocompleteFilter((o) => o?.nome || "")}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(novo.idfuncaoresponsavel)
                ) || null
              }
              onChange={(_, v) => setNovo((p) => ({ ...p, idfuncaoresponsavel: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => (
                <TextField {...params} label="Função responsável" fullWidth />
              )}
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              filterOptions={createAutocompleteFilter((o) => o?.nome || "")}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(novo.idfuncaoequipa)
                ) || null
              }
              onChange={(_, v) => setNovo((p) => ({ ...p, idfuncaoequipa: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => <TextField {...params} label="Função da equipa" fullWidth />}
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <FormControlLabel
                sx={{ ml: 0.5 }}
                control={
                  <Checkbox
                    checked={Number(novo.inativo || 0) === 1}
                    onChange={(e) =>
                      setNovo((p) => ({
                        ...p,
                        inativo: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                }
                label="Inativo"
              />

              <FormControlLabel
                sx={{ ml: 0.5 }}
                control={
                  <Checkbox
                    checked={Boolean(novo.beneficio_empresa)}
                    onChange={(e) =>
                      setNovo((p) => ({
                        ...p,
                        beneficio_empresa: e.target.checked,
                      }))
                    }
                  />
                }
                label="Benefício pago à empresa"
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novo.obs}
                onChange={(e) => setNovo((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenAdd(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={inserir} disabled={loading}>
            Inserir
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            width: "96vw",
            maxWidth: "96vw",
            height: "94vh",
            maxHeight: "94vh",
          },
        }}
      >
        <DialogTitle>Editar Incentivo</DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={sel?.nome || ""}
                onChange={(e) => setSel((p) => ({ ...p, nome: e.target.value.toUpperCase() }))}
                fullWidth
              />
            </MDBox>

            <TextField
              label="Data inicial"
              type="date"
              value={sel?.dataini || ""}
              onChange={(e) => setSel((p) => ({ ...p, dataini: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <TextField
              label="Data final"
              type="date"
              value={sel?.datafim || ""}
              onChange={(e) => setSel((p) => ({ ...p, datafim: e.target.value }))}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />

            <Autocomplete
              options={catalogos?.fabricantes || []}
              filterOptions={createAutocompleteFilter((o) => `${o?.ref || ""} ${o?.nome || ""}`)}
              value={
                (catalogos?.fabricantes || []).find(
                  (x) => String(x.ref || "") === String(sel?.reffabricante || "")
                ) || null
              }
              onChange={(_, v) =>
                setSel((p) => ({
                  ...p,
                  reffabricante: v?.ref || "",
                }))
              }
              getOptionLabel={(o) => (o?.nome ? `${o.nome} (${o.ref})` : o?.ref || "")}
              isOptionEqualToValue={(opt, val) => String(opt?.ref || "") === String(val?.ref || "")}
              renderInput={(params) => <TextField {...params} label="Fabricante" fullWidth />}
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              filterOptions={createAutocompleteFilter((o) => o?.nome || "")}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(sel?.idfuncaoresponsavel)
                ) || null
              }
              onChange={(_, v) => setSel((p) => ({ ...p, idfuncaoresponsavel: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => (
                <TextField {...params} label="Função responsável" fullWidth />
              )}
            />

            <Autocomplete
              options={catalogos?.funcoes || []}
              filterOptions={createAutocompleteFilter((o) => o?.nome || "")}
              value={
                (catalogos?.funcoes || []).find(
                  (x) => Number(x.id) === Number(sel?.idfuncaoequipa)
                ) || null
              }
              onChange={(_, v) => setSel((p) => ({ ...p, idfuncaoequipa: v?.id || null }))}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(opt, val) => Number(opt?.id) === Number(val?.id)}
              renderInput={(params) => <TextField {...params} label="Função da equipa" fullWidth />}
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <FormControlLabel
                sx={{ ml: 0.5 }}
                control={
                  <Checkbox
                    checked={Number(sel?.inativo || 0) === 1}
                    onChange={(e) =>
                      setSel((p) => ({
                        ...p,
                        inativo: e.target.checked ? 1 : 0,
                      }))
                    }
                  />
                }
                label="Inativo"
              />

              <FormControlLabel
                sx={{ ml: 0.5 }}
                control={
                  <Checkbox
                    checked={Boolean(sel?.beneficio_empresa)}
                    onChange={(e) =>
                      setSel((p) => ({
                        ...p,
                        beneficio_empresa: e.target.checked,
                      }))
                    }
                  />
                }
                label="Benefício pago à empresa"
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <TextField
                select
                label="Universo de clientes"
                value={historicoSubmarcas.modo}
                onChange={(e) => {
                  const modo = e.target.value;

                  setHistoricoSubmarcas((p) => ({
                    ...p,
                    modo,
                    datainicial: modo === "TODOS" ? "" : p.datainicial,
                    datafinal: modo === "TODOS" ? "" : p.datafinal,
                    submarcas: modo === "TODOS" ? [] : p.submarcas,
                  }));

                  if (modo === "TODOS") {
                    setSubmarcasHistoricoOptions([]);
                  }
                }}
                SelectProps={{ native: true }}
                fullWidth
              >
                <option value="TODOS">Todos os clientes elegíveis</option>
                <option value="SEM_COMPRAS_SUBMARCAS">
                  Apenas clientes sem compras anteriores das submarcas
                </option>
              </TextField>
            </MDBox>

            {historicoSubmarcas.modo === "SEM_COMPRAS_SUBMARCAS" && (
              <>
                <TextField
                  label="Histórico — data inicial"
                  type="date"
                  value={historicoSubmarcas.datainicial}
                  onChange={(e) =>
                    setHistoricoSubmarcas((p) => ({
                      ...p,
                      datainicial: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />

                <TextField
                  label="Histórico — data final"
                  type="date"
                  value={historicoSubmarcas.datafinal}
                  onChange={(e) =>
                    setHistoricoSubmarcas((p) => ({
                      ...p,
                      datafinal: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                />

                <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={submarcasHistoricoOptions}
                    value={historicoSubmarcas.submarcas}
                    filterOptions={(x) => x}
                    onOpen={() => pesquisarSubmarcasHistorico("")}
                    onInputChange={(_, value, reason) => {
                      if (reason === "input") {
                        pesquisarSubmarcasHistorico(value);
                      }
                    }}
                    onChange={(_, valores) =>
                      setHistoricoSubmarcas((p) => ({
                        ...p,
                        submarcas: Array.isArray(valores) ? valores : [],
                      }))
                    }
                    getOptionLabel={(o) => (o?.nome ? `${o.nome} (${o.ref})` : o?.ref || "")}
                    isOptionEqualToValue={(opt, val) =>
                      String(opt?.ref || "") === String(val?.ref || "")
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Submarcas sem compras no período histórico"
                        placeholder="Pesquisar submarca..."
                        fullWidth
                      />
                    )}
                  />

                  <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                    Só contarão no incentivo clientes que não tenham comprado nenhuma das submarcas
                    selecionadas durante o período histórico.
                  </MDTypography>
                </MDBox>
              </>
            )}

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={sel?.obs || ""}
                onChange={(e) => setSel((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>

          <Divider sx={{ my: 2 }} />

          <MDTypography variant="h6" mb={1}>
            Critérios de clientes elegíveis
          </MDTypography>

          {[
            {
              campo: "segmentopotencial",
              titulo: "Segmento Potencial",
              options: (catalogos?.segmentoPotencial || []).map((x) => ({
                value: String(x?.nome || ""),
                label: String(x?.nome || ""),
              })),
              inverso: false,
            },
            {
              campo: "segmenton1",
              titulo: "Segmento N1",
              options: (catalogos?.segmentoN1 || []).map((x) => ({
                value: String(x?.nome || ""),
                label: String(x?.nome || ""),
              })),
              inverso: false,
            },
            {
              campo: "segmenton2",
              titulo: "Segmento N2",
              options: (catalogos?.segmentoN2 || []).map((x) => ({
                value: String(x?.nome || ""),
                label: String(x?.nome || ""),
              })),
              inverso: false,
            },
            {
              campo: "segmenton3",
              titulo: "Segmento N3",
              options: (catalogos?.segmentoN3 || []).map((x) => ({
                value: String(x?.nome || ""),
                label: String(x?.nome || ""),
              })),
              inverso: false,
            },
            {
              campo: "grupos_clientes",
              titulo: "Grupos de Clientes",
              options: (catalogos?.gruposClientes || []).map((x) => ({
                value: String(x?.ref || ""),
                label: x?.nome ? `${x.nome} (${x.ref})` : String(x?.ref || ""),
              })),
              inverso: false,
            },
            {
              campo: "bloq_for",
              titulo: "Bloqueios de Fornecimento",
              options: (catalogos?.bloqueiosFornecimento || []).map((x) => ({
                value: String(x?.ref || ""),
                label: x?.nome ? `${x.nome} (${x.ref})` : String(x?.ref || ""),
              })),
              inverso: true,
            },
            {
              campo: "bloq_fat",
              titulo: "Bloqueios de Faturação",
              options: (catalogos?.bloqueiosFaturacao || []).map((x) => ({
                value: String(x?.ref || ""),
                label: x?.nome ? `${x.nome} (${x.ref})` : String(x?.ref || ""),
              })),
              inverso: true,
            },
            {
              campo: "bloq_ord",
              titulo: "Bloqueios de Ordem",
              options: (catalogos?.bloqueiosOrdem || []).map((x) => ({
                value: String(x?.ref || ""),
                label: x?.nome ? `${x.nome} (${x.ref})` : String(x?.ref || ""),
              })),
              inverso: true,
            },
          ].map((cfg) => {
            const selecionados = Array.isArray(filtrosClientes?.[cfg.campo])
              ? filtrosClientes[cfg.campo]
              : [];

            const todosValores = cfg.options.map((x) => x.value).filter(Boolean);

            return (
              <Accordion key={cfg.campo} disableGutters sx={{ mb: 1 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <MDBox>
                    <MDTypography variant="button" fontWeight="bold">
                      {cfg.titulo}
                    </MDTypography>

                    <MDTypography variant="caption" color="text" display="block">
                      {cfg.inverso
                        ? `${selecionados.length} bloqueio${
                            selecionados.length === 1 ? "" : "s"
                          } excluído${selecionados.length === 1 ? "" : "s"}`
                        : `${selecionados.length} de ${todosValores.length} selecionado${
                            selecionados.length === 1 ? "" : "s"
                          }`}
                    </MDTypography>
                  </MDBox>
                </AccordionSummary>

                <AccordionDetails>
                  <MDBox display="flex" gap={1} mb={1}>
                    <MDButton
                      size="small"
                      color="info"
                      onClick={() => selecionarTodosFiltroCliente(cfg.campo, todosValores)}
                    >
                      Selecionar todos
                    </MDButton>

                    <MDButton
                      size="small"
                      color="secondary"
                      onClick={() => limparFiltroCliente(cfg.campo)}
                    >
                      Desselecionar todos
                    </MDButton>
                  </MDBox>

                  {cfg.inverso && (
                    <MDTypography variant="caption" color="text" display="block" mb={1}>
                      Os bloqueios selecionados excluem o cliente do apuramento.
                    </MDTypography>
                  )}

                  <MDBox
                    display="grid"
                    gridTemplateColumns={{
                      xs: "1fr",
                      sm: "1fr 1fr",
                      md: "1fr 1fr 1fr",
                    }}
                    columnGap={2}
                    rowGap={0}
                  >
                    {cfg.options.map((opt) => (
                      <FormControlLabel
                        key={`${cfg.campo}-${opt.value}`}
                        sx={{
                          m: 0,
                          minWidth: 0,
                        }}
                        control={
                          <Checkbox
                            size="small"
                            checked={selecionados.some((x) => String(x) === String(opt.value))}
                            onChange={(e) =>
                              toggleFiltroCliente(cfg.campo, opt.value, e.target.checked)
                            }
                          />
                        }
                        label={
                          <MDTypography
                            variant="caption"
                            sx={{
                              overflowWrap: "anywhere",
                            }}
                          >
                            {opt.label}
                          </MDTypography>
                        }
                      />
                    ))}
                  </MDBox>
                </AccordionDetails>
              </Accordion>
            );
          })}

          <MDTypography variant="caption" color="text" display="block" mb={2}>
            Nos segmentos e grupos, os valores selecionados definem os clientes admitidos. Nos
            bloqueios, os valores selecionados identificam os clientes a excluir.
          </MDTypography>

          <Divider sx={{ my: 2 }} />

          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
            <MDTypography variant="h6">Grupos</MDTypography>
          </MDBox>

          {(doc.desafios || []).length === 0 && (
            <MDTypography variant="caption" color="text">
              Ainda não existem grupos configurados para este incentivo.
            </MDTypography>
          )}

          {(doc.desafios || []).map((d) => {
            const materiais = (doc.materiais || []).filter(
              (m) => Number(m.iddesafio) === Number(d.id)
            );

            const materiaisAgrupados = Array.from(
              materiais
                .reduce((map, m) => {
                  const ref = String(m.refmaterial || "");

                  if (!map.has(ref)) {
                    map.set(ref, {
                      ...m,
                      associacoes: [m],
                    });
                  } else {
                    map.get(ref).associacoes.push(m);
                  }

                  return map;
                }, new Map())
                .values()
            );

            const patamares = (doc.patamares || []).filter(
              (p) => Number(p.iddesafio) === Number(d.id)
            );

            const regraClientesQtdMinima = (catalogos?.tiposDesafio || []).find(
              (x) => String(x.codigo || "") === "CLIENTES_QTD_MINIMA"
            );

            const usaClientesQtdMinima =
              Boolean(regraClientesQtdMinima?.id) &&
              (doc.desafiosRegras || []).some(
                (r) =>
                  Number(r.iddesafio) === Number(d.id) &&
                  Number(r.idtipodesafio) === Number(regraClientesQtdMinima.id)
              );

            const temMateriaisBonus = materiais.some(
              (m) => String(m.tipo || "PRINCIPAL") === "BONUS"
            );

            return (
              <Accordion
                key={d.id}
                expanded={expandedDesafio === d.id}
                onChange={(_, isExpanded) => setExpandedDesafio(isExpanded ? d.id : null)}
                disableGutters
                sx={{
                  mb: 1,
                  backgroundColor: "#fff7f0",
                  borderRadius: 2,
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    minHeight: 32,
                    px: 1.5,
                    "& .MuiAccordionSummary-content": { margin: "4px 0" },
                  }}
                >
                  <MDBox display="flex" alignItems="center" width="100%" gap={1.5}>
                    <MDBox display="flex" gap={0.5} onClick={(e) => e.stopPropagation()}>
                      <IconButton color="error" size="small" onClick={() => removerDesafio(d)}>
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </MDBox>

                    <MDBox flex={1}>
                      <MDInput
                        value={d.nome || ""}
                        variant="standard"
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          const nome = e.target.value.toUpperCase();

                          setDoc((prev) => ({
                            ...prev,
                            desafios: prev.desafios.map((x) =>
                              Number(x.id) === Number(d.id) ? { ...x, nome } : x
                            ),
                          }));
                        }}
                        onBlur={async (e) => {
                          const nome = e.target.value.trim();

                          const [_payload, err] = await handleApi(
                            api.post("Comercial/UpdIncentivoDesafio", {
                              id: d.id,
                              idincentivo: sel.id,
                              nome,
                              ordem: d.ordem,
                              ambito_apuramento: d.ambito_apuramento || "VENDEDOR",
                              qtd_minima_cliente: d.qtd_minima_cliente ?? null,
                              qtd_minima_bonus_cliente: d.qtd_minima_bonus_cliente ?? null,
                              obs: d.obs || null,
                            })
                          );

                          if (err) showAlert(err, "error");
                        }}
                        sx={{
                          minWidth: 260,
                          "& input": {
                            fontWeight: 700,
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <MDTypography variant="caption" color="text" display="block">
                        {materiaisAgrupados.length === 0
                          ? "Sem materiais"
                          : materiaisAgrupados
                              .slice(0, 3)
                              .map((m) => `${m.refmaterial} - ${m.material || ""}`.trim())
                              .join(", ")}

                        {materiaisAgrupados.length > 3
                          ? ` e mais ${materiaisAgrupados.length - 3}`
                          : ""}
                      </MDTypography>

                      <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1}
                        mt={0.5}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <MDTypography variant="caption" color="text">
                          Âmbito:
                        </MDTypography>

                        <TextField
                          select
                          variant="standard"
                          value={d.ambito_apuramento || "VENDEDOR"}
                          onChange={async (e) => {
                            const ambito_apuramento = e.target.value;

                            setDoc((prev) => ({
                              ...prev,
                              desafios: prev.desafios.map((x) =>
                                Number(x.id) === Number(d.id) ? { ...x, ambito_apuramento } : x
                              ),
                            }));

                            const [_payload, err] = await handleApi(
                              api.post("Comercial/UpdIncentivoDesafio", {
                                id: d.id,
                                idincentivo: sel.id,
                                nome: d.nome,
                                ordem: d.ordem,
                                ambito_apuramento,
                                qtd_minima_cliente: d.qtd_minima_cliente ?? null,
                                qtd_minima_bonus_cliente: d.qtd_minima_bonus_cliente ?? null,
                                obs: d.obs || null,
                              })
                            );

                            if (err) {
                              showAlert(err, "error");

                              await abrirEdicao({ id: sel.id });
                              setExpandedDesafio(d.id);
                            }
                          }}
                          SelectProps={{ native: true }}
                          sx={{
                            minWidth: 180,
                            "& select": {
                              fontSize: "0.75rem",
                            },
                          }}
                        >
                          <option value="VENDEDOR">Por vendedor</option>
                          <option value="GLOBAL">Global do distribuidor</option>
                        </TextField>
                      </MDBox>

                      <MDTypography variant="caption" color="text" display="block">
                        {
                          (doc.desafiosRegras || []).filter(
                            (r) => Number(r.iddesafio) === Number(d.id)
                          ).length
                        }{" "}
                        regras · {patamares.length} patamares
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                </AccordionSummary>

                <AccordionDetails>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="button" fontWeight="bold">
                      Materiais
                    </MDTypography>

                    <MDButton
                      color="info"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setMaterialTargetDesafio(d);
                        setNovoMaterial({
                          refmaterial: "",
                          fator_equivalencia: "1",
                          tipos: ["PRINCIPAL"],
                        });
                        setMateriaisSel([]);
                        setMateriaisOptions([]);
                        setMaterialPesquisa("");
                        setOpenMaterial(true);
                      }}
                    >
                      + Material
                    </MDButton>
                  </MDBox>

                  <MDBox mt={0.5} mb={1.5}>
                    {materiais.length === 0 ? (
                      <MDTypography variant="caption" color="text">
                        Sem materiais.
                      </MDTypography>
                    ) : (
                      materiaisAgrupados.map((m) => (
                        <MDBox
                          key={m.id}
                          display="grid"
                          gridTemplateColumns={{ xs: "1fr", md: "1fr 120px 120px 40px" }}
                          gap={1}
                          alignItems="center"
                          sx={{
                            borderBottom: "1px solid #f0f0f0",
                            py: 0.5,
                          }}
                        >
                          <MDTypography variant="caption">
                            {m.refmaterial} — {m.material || ""}
                          </MDTypography>

                          <MDBox display="flex" alignItems="center" gap={1}>
                            <FormControlLabel
                              sx={{ m: 0 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={materiais.some(
                                    (x) =>
                                      String(x.refmaterial || "") === String(m.refmaterial || "") &&
                                      String(x.tipo || "PRINCIPAL") === "PRINCIPAL"
                                  )}
                                  onChange={async (e) => {
                                    const checked = e.target.checked;

                                    setLoading(true);

                                    try {
                                      if (checked) {
                                        const [payload, err] = await handleApi(
                                          api.post("Comercial/InsIncentivoDesafioMaterial", {
                                            iddesafio: d.id,
                                            refmaterial: m.refmaterial,
                                            fator_equivalencia: Number(m.fator_equivalencia || 1),
                                            tipo: "PRINCIPAL",
                                          })
                                        );

                                        if (err) return showAlert(err, "error");

                                        setDoc((prev) => ({
                                          ...prev,
                                          materiais: [
                                            ...prev.materiais,
                                            {
                                              id: payload?.id,
                                              iddesafio: d.id,
                                              refmaterial: m.refmaterial,
                                              material: m.material,
                                              fator_equivalencia: Number(m.fator_equivalencia || 1),
                                              tipo: "PRINCIPAL",
                                            },
                                          ],
                                        }));
                                      } else {
                                        const linhaPrincipal = materiais.find(
                                          (x) =>
                                            String(x.refmaterial || "") ===
                                              String(m.refmaterial || "") &&
                                            String(x.tipo || "PRINCIPAL") === "PRINCIPAL"
                                        );

                                        if (linhaPrincipal?.id) {
                                          const [_payload, err] = await handleApi(
                                            api.post("Comercial/DelIncentivoDesafioMaterial", {
                                              id: linhaPrincipal.id,
                                            })
                                          );

                                          if (err) return showAlert(err, "error");

                                          setDoc((prev) => ({
                                            ...prev,
                                            materiais: prev.materiais.filter(
                                              (x) => Number(x.id) !== Number(linhaPrincipal.id)
                                            ),
                                          }));
                                        }
                                      }
                                    } finally {
                                      setLoading(false);
                                    }
                                  }}
                                />
                              }
                              label="Principal"
                            />

                            <FormControlLabel
                              sx={{ m: 0 }}
                              control={
                                <Checkbox
                                  size="small"
                                  checked={materiais.some(
                                    (x) =>
                                      String(x.refmaterial || "") === String(m.refmaterial || "") &&
                                      String(x.tipo || "PRINCIPAL") === "BONUS"
                                  )}
                                  onChange={async (e) => {
                                    const checked = e.target.checked;

                                    setLoading(true);

                                    try {
                                      if (checked) {
                                        const [payload, err] = await handleApi(
                                          api.post("Comercial/InsIncentivoDesafioMaterial", {
                                            iddesafio: d.id,
                                            refmaterial: m.refmaterial,
                                            fator_equivalencia: Number(m.fator_equivalencia || 1),
                                            tipo: "BONUS",
                                          })
                                        );

                                        if (err) return showAlert(err, "error");

                                        setDoc((prev) => ({
                                          ...prev,
                                          materiais: [
                                            ...prev.materiais,
                                            {
                                              id: payload?.id,
                                              iddesafio: d.id,
                                              refmaterial: m.refmaterial,
                                              material: m.material,
                                              fator_equivalencia: Number(m.fator_equivalencia || 1),
                                              tipo: "BONUS",
                                            },
                                          ],
                                        }));
                                      } else {
                                        const linhaBonus = materiais.find(
                                          (x) =>
                                            String(x.refmaterial || "") ===
                                              String(m.refmaterial || "") &&
                                            String(x.tipo || "PRINCIPAL") === "BONUS"
                                        );

                                        if (linhaBonus?.id) {
                                          const [_payload, err] = await handleApi(
                                            api.post("Comercial/DelIncentivoDesafioMaterial", {
                                              id: linhaBonus.id,
                                            })
                                          );

                                          if (err) return showAlert(err, "error");

                                          setDoc((prev) => ({
                                            ...prev,
                                            materiais: prev.materiais.filter(
                                              (x) => Number(x.id) !== Number(linhaBonus.id)
                                            ),
                                          }));
                                        }
                                      }
                                    } finally {
                                      setLoading(false);
                                    }
                                  }}
                                />
                              }
                              label="Bónus"
                            />
                          </MDBox>

                          <MDInput
                            label="Equivalência"
                            value={m.fator_equivalencia ?? 1}
                            variant="standard"
                            onChange={(e) => {
                              const fator_equivalencia = e.target.value;

                              setDoc((prev) => ({
                                ...prev,
                                materiais: prev.materiais.map((x) =>
                                  Number(x.id) === Number(m.id) ? { ...x, fator_equivalencia } : x
                                ),
                              }));
                            }}
                            onBlur={async (e) => {
                              const fator = Number(String(e.target.value || "").replace(",", "."));

                              if (!Number.isFinite(fator) || fator <= 0) {
                                showAlert(
                                  "O fator de equivalência tem de ser superior a zero.",
                                  "warning"
                                );

                                setDoc((prev) => ({
                                  ...prev,
                                  materiais: prev.materiais.map((x) =>
                                    Number(x.id) === Number(m.id)
                                      ? { ...x, fator_equivalencia: m.fator_equivalencia ?? 1 }
                                      : x
                                  ),
                                }));

                                return;
                              }

                              setLoading(true);

                              try {
                                const [_payload, err, meta] = await handleApi(
                                  api.post("Comercial/UpdIncentivoDesafioMaterial", {
                                    id: m.id,
                                    fator_equivalencia: fator,
                                    tipo: m.tipo || "PRINCIPAL",
                                  })
                                );

                                if (err) {
                                  showAlert(err, "error");
                                  await abrirEdicao({ id: sel.id });
                                  setExpandedDesafio(d.id);
                                  return;
                                }

                                showAlert(
                                  meta?.message || "Fator de equivalência atualizado.",
                                  meta?.severity || "success"
                                );

                                await abrirEdicao({ id: sel.id });
                                setExpandedDesafio(d.id);
                              } finally {
                                setLoading(false);
                              }
                            }}
                            sx={{
                              width: 110,
                              "& input": {
                                fontSize: "0.75rem",
                                textAlign: "center",
                              },
                            }}
                          />

                          <IconButton
                            color="error"
                            size="small"
                            onClick={() => removerMaterialCompleto(m, d.id)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </MDBox>
                      ))
                    )}
                  </MDBox>

                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography variant="button" fontWeight="bold">
                      Patamares
                    </MDTypography>

                    <MDButton
                      color="info"
                      size="small"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        const tipos = catalogos?.tiposBeneficio || [];
                        setPatamarEditId(0);
                        setPatamarTargetDesafio(d);
                        setNovoPatamar({
                          ordem: patamares.length + 1,
                          descricao: "",
                          idtipobeneficio: tipos?.[0]?.id || "",
                          beneficio: "",
                          beneficio_aplicacao: "FIXO",
                          obs: "",
                        });
                        setOpenPatamar(true);
                      }}
                    >
                      + Patamar
                    </MDButton>
                  </MDBox>

                  <MDBox mt={0.5}>
                    {patamares.length === 0 ? (
                      <MDTypography variant="caption" color="text">
                        Sem patamares.
                      </MDTypography>
                    ) : (
                      patamares.map((p) => {
                        const condicoes = (doc.condicoes || []).filter(
                          (c) => Number(c.idpatamar) === Number(p.id)
                        );

                        return (
                          <Accordion
                            key={p.id}
                            expanded={expandedPatamar === p.id}
                            onChange={(_, isExpanded) =>
                              setExpandedPatamar(isExpanded ? p.id : null)
                            }
                            disableGutters
                            sx={{
                              mb: 1,
                              backgroundColor: "#fff7f0",
                              borderRadius: 2,
                              "&:before": { display: "none" },
                            }}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon sx={{ fontSize: 18 }} />}
                              sx={{
                                minHeight: 32,
                                px: 1.5,
                                "& .MuiAccordionSummary-content": { margin: "4px 0" },
                              }}
                            >
                              <MDBox display="flex" gap={0.5} onClick={(e) => e.stopPropagation()}>
                                <IconButton
                                  color="error"
                                  size="small"
                                  onClick={() => removerPatamar(p, d.id)}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </MDBox>

                              <MDBox display="flex" alignItems="center" width="100%" gap={1}>
                                <MDBox flex={1}>
                                  <MDInput
                                    value={p.descricao || `PATAMAR ${p.ordem || ""}`}
                                    variant="standard"
                                    onClick={(e) => e.stopPropagation()}
                                    onChange={(e) => {
                                      const descricao = e.target.value.toUpperCase();

                                      setDoc((prev) => ({
                                        ...prev,
                                        patamares: prev.patamares.map((x) =>
                                          Number(x.id) === Number(p.id) ? { ...x, descricao } : x
                                        ),
                                      }));
                                    }}
                                    onBlur={async (e) => {
                                      const descricao = e.target.value.trim().toUpperCase();

                                      const [_payload, err] = await handleApi(
                                        api.post("Comercial/UpdIncentivoPatamar", {
                                          id: p.id,
                                          iddesafio: d.id,
                                          ordem: p.ordem || 1,
                                          descricao,
                                          idtipobeneficio: p.idtipobeneficio,
                                          beneficio: p.beneficio || null,
                                          beneficio_aplicacao: p.beneficio_aplicacao || "FIXO",
                                          obs: p.obs || null,
                                        })
                                      );

                                      if (err) showAlert(err, "error");
                                    }}
                                    sx={{
                                      minWidth: 180,
                                      "& input": {
                                        fontWeight: 700,
                                        fontSize: "0.875rem",
                                      },
                                    }}
                                  />

                                  <MDTypography variant="caption" color="text" display="block">
                                    {condicoes.length === 0
                                      ? "Sem condições"
                                      : condicoes
                                          .map((c) => {
                                            const nome = c.tipocondicao || "";
                                            const operador = c.operador_codigo || "";
                                            const unidade = c.tipocondicao_unidade || "";

                                            return `${nome} ${operador} ${c.valor}${
                                              unidade ? ` ${unidade}` : ""
                                            }`;
                                          })
                                          .join(" · ")}
                                  </MDTypography>

                                  <MDBox
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <MDTypography variant="caption" color="primary">
                                      ➜
                                    </MDTypography>

                                    <TextField
                                      select
                                      variant="standard"
                                      value={p.idtipobeneficio || ""}
                                      onChange={async (e) => {
                                        const idtipobeneficio = Number(e.target.value || 0);
                                        const tipo = (catalogos?.tiposBeneficio || []).find(
                                          (x) => Number(x.id) === idtipobeneficio
                                        );

                                        setDoc((prev) => ({
                                          ...prev,
                                          patamares: prev.patamares.map((x) =>
                                            Number(x.id) === Number(p.id)
                                              ? {
                                                  ...x,
                                                  idtipobeneficio,
                                                  tipobeneficio: tipo?.codigo || x.tipobeneficio,
                                                  tipobeneficio_nome:
                                                    tipo?.nome || x.tipobeneficio_nome,
                                                  beneficio_aplicacao:
                                                    tipo?.codigo === "VALOR_POR_UNIDADE"
                                                      ? x.beneficio_aplicacao === "EXCEDENTE"
                                                        ? "EXCEDENTE"
                                                        : "POR_UNIDADE"
                                                      : "FIXO",
                                                }
                                              : x
                                          ),
                                        }));

                                        const [_payload, err] = await handleApi(
                                          api.post("Comercial/UpdIncentivoPatamar", {
                                            id: p.id,
                                            iddesafio: d.id,
                                            ordem: p.ordem || 1,
                                            descricao: p.descricao || null,
                                            idtipobeneficio,
                                            beneficio: p.beneficio || null,
                                            beneficio_aplicacao:
                                              tipo?.codigo === "VALOR_POR_UNIDADE"
                                                ? p.beneficio_aplicacao === "EXCEDENTE"
                                                  ? "EXCEDENTE"
                                                  : "POR_UNIDADE"
                                                : "FIXO",
                                            obs: p.obs || null,
                                          })
                                        );

                                        if (err) showAlert(err, "error");
                                      }}
                                      SelectProps={{ native: true }}
                                      sx={{
                                        minWidth: 130,
                                        "& select": { fontSize: "0.75rem" },
                                      }}
                                    >
                                      {(catalogos?.tiposBeneficio || []).map((x) => (
                                        <option key={x.id} value={x.id}>
                                          {x.nome}
                                        </option>
                                      ))}
                                    </TextField>

                                    {p.tipobeneficio === "VALOR_POR_UNIDADE" && (
                                      <TextField
                                        select
                                        variant="standard"
                                        value={p.beneficio_aplicacao || "FIXO"}
                                        onChange={async (e) => {
                                          const beneficio_aplicacao = e.target.value;

                                          setDoc((prev) => ({
                                            ...prev,
                                            patamares: prev.patamares.map((x) =>
                                              Number(x.id) === Number(p.id)
                                                ? { ...x, beneficio_aplicacao }
                                                : x
                                            ),
                                          }));

                                          const [_payload, err] = await handleApi(
                                            api.post("Comercial/UpdIncentivoPatamar", {
                                              id: p.id,
                                              iddesafio: d.id,
                                              ordem: p.ordem || 1,
                                              descricao: p.descricao || null,
                                              idtipobeneficio: p.idtipobeneficio,
                                              beneficio: p.beneficio || null,
                                              beneficio_aplicacao,
                                              obs: p.obs || null,
                                            })
                                          );

                                          if (err) showAlert(err, "error");
                                        }}
                                        SelectProps={{ native: true }}
                                        sx={{
                                          minWidth: 210,
                                          "& select": { fontSize: "0.75rem" },
                                        }}
                                      >
                                        <option value="POR_UNIDADE">Todas as unidades</option>
                                        <option value="POR_UNIDADE_EQUIVALENTE">
                                          Todas as unidades equivalentes
                                        </option>
                                        <option value="EXCEDENTE">
                                          Acima da quantidade mínima
                                        </option>
                                        <option value="PRIMEIRA_COMPRA_CLIENTE_MATERIAL">
                                          Primeira compra por cliente/material
                                        </option>
                                        <option value="POR_CLIENTE_ELEGIVEL">
                                          Por cliente elegível
                                        </option>
                                        <option value="POR_CLIENTE_BONUS">
                                          Por cliente elegível com bónus
                                        </option>
                                      </TextField>
                                    )}

                                    <MDInput
                                      value={p.beneficio || ""}
                                      variant="standard"
                                      onChange={(e) => {
                                        const beneficio = e.target.value;

                                        setDoc((prev) => ({
                                          ...prev,
                                          patamares: prev.patamares.map((x) =>
                                            Number(x.id) === Number(p.id) ? { ...x, beneficio } : x
                                          ),
                                        }));
                                      }}
                                      onBlur={async (e) => {
                                        const beneficio = e.target.value.trim();

                                        const [_payload, err] = await handleApi(
                                          api.post("Comercial/UpdIncentivoPatamar", {
                                            id: p.id,
                                            iddesafio: d.id,
                                            ordem: p.ordem || 1,
                                            descricao: p.descricao || null,
                                            idtipobeneficio: p.idtipobeneficio,
                                            beneficio,
                                            beneficio_aplicacao: p.beneficio_aplicacao || "FIXO",
                                            obs: p.obs || null,
                                          })
                                        );

                                        if (err) showAlert(err, "error");
                                      }}
                                      sx={{
                                        width: 120,
                                        "& input": { fontSize: "0.75rem" },
                                      }}
                                    />
                                  </MDBox>
                                </MDBox>
                              </MDBox>
                            </AccordionSummary>

                            <AccordionDetails>
                              <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                              >
                                <MDTypography variant="button" fontWeight="bold">
                                  Condições
                                </MDTypography>

                                <MDButton
                                  color="info"
                                  size="small"
                                  startIcon={<AddIcon />}
                                  onClick={() => {
                                    const tiposCond = catalogos?.tiposCondicao || [];
                                    const tiposOp = catalogos?.tiposOperador || [];

                                    setCondicaoEditId(0);
                                    setCondicaoTargetPatamar(p);
                                    setCondicaoTargetDesafio(d);
                                    setNovaCondicao({
                                      ordem: condicoes.length + 1,
                                      idtipocondicao: tiposCond?.[0]?.id || "",
                                      idtipooperador:
                                        tiposOp?.find((x) => x.codigo === ">=")?.id ||
                                        tiposOp?.[0]?.id ||
                                        "",
                                      valor: "",
                                      obs: "",
                                    });
                                    setOpenCondicao(true);
                                  }}
                                >
                                  + Nova condição
                                </MDButton>
                              </MDBox>

                              <MDBox mt={0.5}>
                                {condicoes.length === 0 ? (
                                  <MDTypography variant="caption" color="text">
                                    Sem condições.
                                  </MDTypography>
                                ) : (
                                  condicoes.map((c) => (
                                    <MDBox
                                      key={c.id}
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="center"
                                      gap={1}
                                      sx={{
                                        borderBottom: "1px solid #f0f0f0",
                                        py: 0.5,
                                      }}
                                    >
                                      <MDBox
                                        display="grid"
                                        gridTemplateColumns="1fr 80px 100px 80px"
                                        gap={1}
                                        alignItems="center"
                                        flex={1}
                                      >
                                        <TextField
                                          select
                                          variant="standard"
                                          value={c.idtipocondicao || ""}
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={async (e) => {
                                            const idtipocondicao = Number(e.target.value || 0);
                                            const tipo = (catalogos?.tiposCondicao || []).find(
                                              (x) => Number(x.id) === idtipocondicao
                                            );

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id)
                                                  ? {
                                                      ...x,
                                                      idtipocondicao,
                                                      tipocondicao: tipo?.nome || x.tipocondicao,
                                                      tipocondicao_codigo:
                                                        tipo?.codigo || x.tipocondicao_codigo,
                                                      tipocondicao_unidade:
                                                        tipo?.unidademedida || "",
                                                    }
                                                  : x
                                              ),
                                            }));

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao,
                                                idtipooperador: c.idtipooperador,
                                                valor: Number(
                                                  String(c.valor || "0").replace(",", ".")
                                                ),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          SelectProps={{ native: true }}
                                          sx={{
                                            minWidth: 160,
                                            "& select": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        >
                                          {(catalogos?.tiposCondicao || []).map((x) => (
                                            <option key={x.id} value={x.id}>
                                              {x.nome}
                                            </option>
                                          ))}
                                        </TextField>

                                        <TextField
                                          select
                                          variant="standard"
                                          value={c.idtipooperador || ""}
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={async (e) => {
                                            const idtipooperador = Number(e.target.value || 0);
                                            const op = (catalogos?.tiposOperador || []).find(
                                              (x) => Number(x.id) === idtipooperador
                                            );

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id)
                                                  ? {
                                                      ...x,
                                                      idtipooperador,
                                                      operador_codigo:
                                                        op?.codigo || x.operador_codigo,
                                                      operador: op?.nome || x.operador,
                                                    }
                                                  : x
                                              ),
                                            }));

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao: c.idtipocondicao,
                                                idtipooperador,
                                                valor: Number(
                                                  String(c.valor || "0").replace(",", ".")
                                                ),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          SelectProps={{ native: true }}
                                          sx={{
                                            width: 70,
                                            "& select": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        >
                                          {(catalogos?.tiposOperador || []).map((x) => (
                                            <option key={x.id} value={x.id}>
                                              {x.codigo}
                                            </option>
                                          ))}
                                        </TextField>

                                        <MDInput
                                          value={c.valor ?? ""}
                                          variant="standard"
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={(e) => {
                                            const valor = e.target.value;

                                            setDoc((prev) => ({
                                              ...prev,
                                              condicoes: prev.condicoes.map((x) =>
                                                Number(x.id) === Number(c.id) ? { ...x, valor } : x
                                              ),
                                            }));
                                          }}
                                          onBlur={async (e) => {
                                            const valor = String(e.target.value || "").replace(
                                              ",",
                                              "."
                                            );

                                            if (valor.trim() === "")
                                              return showAlert("Indica o valor.", "warning");

                                            const [_payload, err] = await handleApi(
                                              api.post("Comercial/UpdIncentivoCondicao", {
                                                id: c.id,
                                                idpatamar: p.id,
                                                idtipocondicao: c.idtipocondicao,
                                                idtipooperador: c.idtipooperador,
                                                valor: Number(valor),
                                                ordem: c.ordem || 1,
                                                obs: c.obs || null,
                                              })
                                            );

                                            if (err) showAlert(err, "error");
                                          }}
                                          sx={{
                                            width: 80,
                                            "& input": {
                                              fontSize: "0.75rem",
                                            },
                                          }}
                                        />

                                        <MDTypography variant="caption">
                                          {c.tipocondicao_unidade || ""}
                                        </MDTypography>
                                      </MDBox>

                                      <MDBox display="flex" gap={0.5}>
                                        <IconButton
                                          color="error"
                                          size="small"
                                          onClick={() => removerCondicao(c, p, d)}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </MDBox>
                                    </MDBox>
                                  ))
                                )}
                              </MDBox>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })
                    )}
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDTypography variant="button" fontWeight="bold">
                      Regras de avaliação
                    </MDTypography>

                    <MDBox display="flex" flexWrap="wrap" gap={1} mt={0.5}>
                      {(catalogos?.tiposDesafio || []).map((regra) => {
                        const checked = (doc.desafiosRegras || []).some(
                          (r) =>
                            Number(r.iddesafio) === Number(d.id) &&
                            Number(r.idtipodesafio) === Number(regra.id)
                        );

                        return (
                          <FormControlLabel
                            key={regra.id}
                            control={
                              <Checkbox
                                size="small"
                                checked={checked}
                                onChange={(e) => toggleRegraDesafio(d, regra.id, e.target.checked)}
                              />
                            }
                            label={regra.nome}
                          />
                        );
                      })}
                    </MDBox>

                    {usaClientesQtdMinima && (
                      <MDBox display="flex" flexWrap="wrap" gap={2} mt={1.5}>
                        <MDBox maxWidth={280} width="100%">
                          <MDInput
                            label="Quantidade mínima por cliente"
                            value={d.qtd_minima_cliente ?? ""}
                            onChange={(e) => {
                              const qtd_minima_cliente = e.target.value;

                              setDoc((prev) => ({
                                ...prev,
                                desafios: prev.desafios.map((x) =>
                                  Number(x.id) === Number(d.id) ? { ...x, qtd_minima_cliente } : x
                                ),
                              }));
                            }}
                            onBlur={async (e) => {
                              const texto = String(e.target.value || "").replace(",", ".");
                              const valor = Number(texto);

                              if (!Number.isFinite(valor) || valor <= 0) {
                                showAlert(
                                  "A quantidade mínima por cliente tem de ser superior a zero.",
                                  "warning"
                                );

                                await abrirEdicao({ id: sel.id });
                                setExpandedDesafio(d.id);
                                return;
                              }

                              setLoading(true);

                              try {
                                const [_payload, err, meta] = await handleApi(
                                  api.post("Comercial/UpdIncentivoDesafio", {
                                    id: d.id,
                                    idincentivo: sel.id,
                                    nome: d.nome,
                                    ordem: d.ordem,
                                    ambito_apuramento: d.ambito_apuramento || "VENDEDOR",
                                    qtd_minima_cliente: valor,
                                    qtd_minima_bonus_cliente: d.qtd_minima_bonus_cliente ?? null,
                                    obs: d.obs || null,
                                  })
                                );

                                if (err) {
                                  showAlert(err, "error");
                                  await abrirEdicao({ id: sel.id });
                                  setExpandedDesafio(d.id);
                                  return;
                                }

                                showAlert(
                                  meta?.message || "Quantidade mínima por cliente atualizada.",
                                  meta?.severity || "success"
                                );

                                await abrirEdicao({ id: sel.id });
                                setExpandedDesafio(d.id);
                              } finally {
                                setLoading(false);
                              }
                            }}
                            fullWidth
                          />

                          <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                            Quantidade equivalente mínima dos materiais principais que cada cliente
                            tem de atingir para contar como PDV.
                          </MDTypography>
                        </MDBox>

                        {temMateriaisBonus && (
                          <MDBox maxWidth={280} width="100%">
                            <MDInput
                              label="Quantidade mínima bónus por cliente"
                              value={d.qtd_minima_bonus_cliente ?? ""}
                              onChange={(e) => {
                                const qtd_minima_bonus_cliente = e.target.value;

                                setDoc((prev) => ({
                                  ...prev,
                                  desafios: prev.desafios.map((x) =>
                                    Number(x.id) === Number(d.id)
                                      ? { ...x, qtd_minima_bonus_cliente }
                                      : x
                                  ),
                                }));
                              }}
                              onBlur={async (e) => {
                                const texto = String(e.target.value || "").replace(",", ".");
                                const valor = Number(texto);

                                if (!Number.isFinite(valor) || valor <= 0) {
                                  showAlert(
                                    "A quantidade mínima de bónus por cliente tem de ser superior a zero.",
                                    "warning"
                                  );

                                  await abrirEdicao({ id: sel.id });
                                  setExpandedDesafio(d.id);
                                  return;
                                }

                                setLoading(true);

                                try {
                                  const [_payload, err, meta] = await handleApi(
                                    api.post("Comercial/UpdIncentivoDesafio", {
                                      id: d.id,
                                      idincentivo: sel.id,
                                      nome: d.nome,
                                      ordem: d.ordem,
                                      ambito_apuramento: d.ambito_apuramento || "VENDEDOR",
                                      qtd_minima_cliente: d.qtd_minima_cliente ?? null,
                                      qtd_minima_bonus_cliente: valor,
                                      obs: d.obs || null,
                                    })
                                  );

                                  if (err) {
                                    showAlert(err, "error");
                                    await abrirEdicao({ id: sel.id });
                                    setExpandedDesafio(d.id);
                                    return;
                                  }

                                  showAlert(
                                    meta?.message || "Quantidade mínima de bónus atualizada.",
                                    meta?.severity || "success"
                                  );

                                  await abrirEdicao({ id: sel.id });
                                  setExpandedDesafio(d.id);
                                } finally {
                                  setLoading(false);
                                }
                              }}
                              fullWidth
                            />

                            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                              Quantidade mínima dos materiais de bónus que o cliente elegível tem de
                              comprar para receber o acréscimo.
                            </MDTypography>
                          </MDBox>
                        )}
                      </MDBox>
                    )}
                  </MDBox>
                </AccordionDetails>
              </Accordion>
            );
          })}

          <Divider sx={{ my: 2 }} />

          <Accordion disableGutters sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <MDTypography variant="h6">Clientes excluídos por acordos/descontos</MDTypography>
            </AccordionSummary>

            <AccordionDetails>
              {(doc.clientesExcluidos || []).length === 0 ? (
                <MDTypography variant="caption" color="text">
                  Sem clientes excluídos automaticamente.
                </MDTypography>
              ) : (
                <MDBox display="grid" gap={0.5}>
                  {(doc.clientesExcluidos || []).map((c) => (
                    <MDBox
                      key={`${c.refcliente}-${c.origem}-${c.reffabricante}`}
                      display="grid"
                      gridTemplateColumns="140px 1fr 220px 220px"
                      gap={1}
                      alignItems="center"
                      sx={{ borderBottom: "1px solid #eee", py: 0.5 }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            checked={Number(c.incluido || 0) === 1}
                            onChange={(e) =>
                              atualizarClientesIncluidos(c.refcliente, e.target.checked)
                            }
                          />
                        }
                        label="Incluir"
                      />

                      <MDTypography variant="caption">
                        {c.cliente || c.refcliente} ({c.refcliente})
                      </MDTypography>

                      <MDTypography variant="caption">
                        {c.fabricante || c.reffabricante || ""}
                      </MDTypography>

                      <MDTypography variant="caption" color="text">
                        {c.acordo || c.origem || ""}
                      </MDTypography>
                    </MDBox>
                  ))}
                </MDBox>
              )}
            </AccordionDetails>
          </Accordion>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <MDButton color="info" size="small" startIcon={<AddIcon />} onClick={criarGrupoRapido}>
            Novo grupo
          </MDButton>

          <MDBox display="flex" gap={1}>
            <MDButton color="secondary" onClick={() => setOpenEdit(false)}>
              Cancelar
            </MDButton>

            <MDButton color="success" onClick={gravarEdicao} disabled={loading}>
              Guardar
            </MDButton>
          </MDBox>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDesafio}
        onClose={() => setOpenDesafio(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {desafioEditId ? "Editar grupo" : "Novo grupo"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Nome"
                value={novoDesafio.nome}
                onChange={(e) =>
                  setNovoDesafio((p) => ({ ...p, nome: e.target.value.toUpperCase() }))
                }
                fullWidth
              />
            </MDBox>

            <TextField
              label="Ordem"
              type="number"
              value={novoDesafio.ordem}
              onChange={(e) => setNovoDesafio((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novoDesafio.obs}
                onChange={(e) => setNovoDesafio((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenDesafio(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarDesafio} disabled={loading}>
            {desafioEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMaterial}
        onClose={() => setOpenMaterial(false)}
        maxWidth="xs"
        fullWidth
        PaperComponent={PaperComponent}
        PaperProps={{
          sx: {
            maxHeight: "72vh",
          },
        }}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          Adicionar material
        </DialogTitle>
        <DialogContent
          sx={{
            overflowY: "auto",
          }}
        >
          <MDBox mt={1}>
            <Autocomplete
              multiple
              disableCloseOnSelect
              options={materiaisOptions}
              filterOptions={(x) => x}
              ListboxProps={{
                style: {
                  maxHeight: 240,
                },
              }}
              value={materiaisSel}
              inputValue={materialPesquisa}
              onChange={(_, valores) => {
                setMateriaisSel(Array.isArray(valores) ? valores : []);
              }}
              onInputChange={(_, v, reason) => {
                if (reason === "input") {
                  setMaterialPesquisa(v);
                  pesquisarMateriais(v);
                }

                if (reason === "clear") {
                  setMaterialPesquisa("");
                  setMateriaisOptions([]);
                }
              }}
              getOptionLabel={(o) => (o?.nome ? `${o.nome} (${o.ref})` : o?.ref || "")}
              isOptionEqualToValue={(opt, val) => String(opt?.ref || "") === String(val?.ref || "")}
              renderInput={(params) => (
                <TextField {...params} label="Material" size="small" fullWidth />
              )}
            />

            <MDBox mt={1.5}>
              <MDInput
                label="Fator de equivalência"
                value={novoMaterial.fator_equivalencia}
                onChange={(e) =>
                  setNovoMaterial((p) => ({
                    ...p,
                    fator_equivalencia: e.target.value,
                  }))
                }
                fullWidth
              />
            </MDBox>

            <MDBox mt={1.5}>
              <MDTypography variant="caption" color="text" display="block" mb={0.5}>
                Utilização do material
              </MDTypography>

              <MDBox display="flex" gap={2}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(novoMaterial.tipos || []).includes("PRINCIPAL")}
                      onChange={(e) => {
                        const checked = e.target.checked;

                        setNovoMaterial((p) => {
                          const atuais = Array.isArray(p.tipos) ? p.tipos : [];

                          return {
                            ...p,
                            tipos: checked
                              ? Array.from(new Set([...atuais, "PRINCIPAL"]))
                              : atuais.filter((x) => x !== "PRINCIPAL"),
                          };
                        });

                        setMateriaisSel([]);
                        setMateriaisOptions([]);
                        setMaterialPesquisa("");
                      }}
                    />
                  }
                  label="Principal"
                />

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={(novoMaterial.tipos || []).includes("BONUS")}
                      onChange={(e) => {
                        const checked = e.target.checked;

                        setNovoMaterial((p) => {
                          const atuais = Array.isArray(p.tipos) ? p.tipos : [];

                          return {
                            ...p,
                            tipos: checked
                              ? Array.from(new Set([...atuais, "BONUS"]))
                              : atuais.filter((x) => x !== "BONUS"),
                          };
                        });

                        setMateriaisSel([]);
                        setMateriaisOptions([]);
                        setMaterialPesquisa("");
                      }}
                    />
                  }
                  label="Bónus"
                />
              </MDBox>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenMaterial(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={adicionarMaterial} disabled={loading}>
            Inserir
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPatamar}
        onClose={() => setOpenPatamar(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {patamarEditId ? "Editar patamar" : "Novo patamar"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <TextField
              label="Ordem"
              type="number"
              value={novoPatamar.ordem}
              onChange={(e) => setNovoPatamar((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <TextField
              select
              label="Tipo de benefício"
              value={novoPatamar.idtipobeneficio}
              onChange={(e) => {
                const idtipobeneficio = e.target.value;
                const tipo = (catalogos?.tiposBeneficio || []).find(
                  (x) => Number(x.id) === Number(idtipobeneficio)
                );

                setNovoPatamar((p) => ({
                  ...p,
                  idtipobeneficio,
                  beneficio_aplicacao:
                    tipo?.codigo === "VALOR_POR_UNIDADE" ? "POR_UNIDADE" : "FIXO",
                }));
              }}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposBeneficio || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Descrição"
                value={novoPatamar.descricao}
                onChange={(e) =>
                  setNovoPatamar((p) => ({ ...p, descricao: e.target.value.toUpperCase() }))
                }
                fullWidth
              />
            </MDBox>

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Benefício"
                value={novoPatamar.beneficio}
                onChange={(e) => setNovoPatamar((p) => ({ ...p, beneficio: e.target.value }))}
                fullWidth
              />
            </MDBox>

            {(catalogos?.tiposBeneficio || []).find(
              (x) => Number(x.id) === Number(novoPatamar.idtipobeneficio)
            )?.codigo === "VALOR_POR_UNIDADE" && (
              <TextField
                select
                label="Aplicar benefício"
                value={novoPatamar.beneficio_aplicacao}
                onChange={(e) =>
                  setNovoPatamar((p) => ({
                    ...p,
                    beneficio_aplicacao: e.target.value,
                  }))
                }
                SelectProps={{ native: true }}
                fullWidth
              >
                <option value="POR_UNIDADE">Todas as unidades</option>
                <option value="POR_UNIDADE_EQUIVALENTE">Todas as unidades equivalentes</option>
                <option value="EXCEDENTE">Apenas às unidades acima da quantidade mínima</option>
                <option value="PRIMEIRA_COMPRA_CLIENTE_MATERIAL">
                  Apenas na primeira compra por cliente/material
                </option>
                <option value="POR_CLIENTE_ELEGIVEL">Por cliente elegível</option>
                <option value="POR_CLIENTE_BONUS">Por cliente elegível com bónus</option>
              </TextField>
            )}

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novoPatamar.obs}
                onChange={(e) => setNovoPatamar((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenPatamar(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarPatamar} disabled={loading}>
            {patamarEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openCondicao}
        onClose={() => setOpenCondicao(false)}
        maxWidth="sm"
        fullWidth
        PaperComponent={PaperComponent}
      >
        <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
          {condicaoEditId ? "Editar condição" : "Nova condição"}
        </DialogTitle>
        <DialogContent>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5} mt={1}>
            <TextField
              label="Ordem"
              type="number"
              value={novaCondicao.ordem}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, ordem: e.target.value }))}
              fullWidth
            />

            <TextField
              select
              label="Tipo de condição"
              value={novaCondicao.idtipocondicao}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, idtipocondicao: e.target.value }))}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposCondicao || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Operador"
              value={novaCondicao.idtipooperador}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, idtipooperador: e.target.value }))}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">(Selecionar)</option>
              {(catalogos?.tiposOperador || []).map((x) => (
                <option key={x.id} value={x.id}>
                  {x.nome}
                </option>
              ))}
            </TextField>

            <MDInput
              label="Valor"
              value={novaCondicao.valor}
              onChange={(e) => setNovaCondicao((p) => ({ ...p, valor: e.target.value }))}
              fullWidth
            />

            <MDBox gridColumn={{ xs: "auto", md: "1 / span 2" }}>
              <MDInput
                label="Observações"
                value={novaCondicao.obs}
                onChange={(e) => setNovaCondicao((p) => ({ ...p, obs: e.target.value }))}
                fullWidth
                multiline
                rows={3}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton color="secondary" onClick={() => setOpenCondicao(false)}>
            Cancelar
          </MDButton>
          <MDButton color="success" onClick={gravarCondicao} disabled={loading}>
            {condicaoEditId ? "Guardar" : "Inserir"}
          </MDButton>
        </DialogActions>
      </Dialog>

      <DialogIncentivoResultados
        PaperComponent={PaperComponent}
        open={openResultados}
        onClose={() => setOpenResultados(false)}
        incentivo={incentivoResultados}
        periodo={periodoResultados}
        setPeriodo={setPeriodoResultados}
        resultados={resultados}
        loading={loading}
        onConsultar={() => carregarResultados(incentivoResultados, periodoResultados)}
        abrirResultadoDetalhe={abrirResultadoDetalhe}
      />

      <DialogIncentivoResultadoDetalhe
        PaperComponent={PaperComponent}
        open={openResultadoDetalhe}
        onClose={() => setOpenResultadoDetalhe(false)}
        titulo={resultadoDetalheTitulo}
        data={resultadoDetalhe}
        loading={loading}
      />
    </DashboardLayout>
  );
}
